import * as styles from "./YearPickerYear.css";

import type { JSX } from "react";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerYearProps } from "./YearPicker.types";

export function YearPickerYear({
  year,
  selected,
  current,
  active,
  disabled,
  outside,
}: YearPickerYearProps): JSX.Element {
  const { selectYear } = useYearPickerContext();

  return (
    <button
      type="button"
      role="gridcell"
      data-slot="year-picker-year"
      data-year={year}
      data-current={current ? "" : undefined}
      data-selected={selected ? "" : undefined}
      data-outside={outside ? "" : undefined}
      aria-selected={selected}
      aria-disabled={disabled}
      tabIndex={active ? 0 : -1}
      disabled={disabled}
      className={styles.year}
      onClick={() => selectYear(year)}
    >
      <span className={styles.band}>
        <span className={styles.ring} />
        <span className={styles.ring} />
      </span>
      <span className={styles.label}>{year}</span>
    </button>
  );
}
